import { getDataFromServer, putDataToServer } from '../../../util';

export class RiskScoreHistoryModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  updateRiskScoreHistory = async (payload) => {
    const { customerKey, changeFrom, changeTo, reason } = payload;

    const data = { customerKey, changeFrom, changeTo, reason };

    const response = await putDataToServer(
      `${this.baseURL}/riskHistory/update`,
      this.httpHeaders,
      {},
      data
    );

    if (response instanceof Error) throw response;
    return response;
  };

  getRiskScoreHistory = async (payload) => {
    const { customerKey, limit, offset } = payload;

    const params = {
      limit,
      offset
    };

    const response = await getDataFromServer(
      `${this.baseURL}/riskHistory/${customerKey}`,
      this.httpHeaders,
      params
    );

    if (response instanceof Error) throw response;
    return response;
  };
}
